export const routes = {
  getUserData: () => `/user/check`,
};
